export function isTouchDevice(win = globalThis) {
  if (!win) return false;
  const coarse = win.matchMedia ? win.matchMedia('(pointer: coarse)').matches : false;
  const touchEvents = 'ontouchstart' in win;
  const points = win.navigator && win.navigator.maxTouchPoints > 0;
  return Boolean(coarse || touchEvents || points);
}
